import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { getSortState, JhiItemCount, JhiPagination } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getParents } from './parent.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Table, Tag, Space, Button, Row, Form, Spin, Input, Select } from 'antd';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { SearchOutlined } from '@ant-design/icons';

export const Parent = (props: RouteComponentProps<{ ecoleId: string }>) => {
  const dispatch = useAppDispatch();

  const currentEcole = useAppSelector(state => state.ecole.entity);
  const loading = useAppSelector(state => state.parent.loading);
  const totalItems = useAppSelector(state => state.parent.totalItems);
  const parentList = useAppSelector(state => state.parent.userParents);
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleId));
    sortEntities();
  }, []);

  const parentListe = () => {
    const entity = {
      ecoleId: props.match.params.ecoleId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getParents(entity));
  };

  const sortEntities = () => {
    parentListe();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    if (page) {
      setPaginationState({
        ...paginationState,
        activePage: +page,
      });
    }
  }, [props.location.search]);

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const onSearch = val => {
    const entity = {
      ...val,
      ecoleId: props.match.params.ecoleId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getParents(entity));
    let firstName, lastName;
    let searchUrl = '';
    let activated;
    let telephone;
    if (entity.firstName) {
      firstName = '&firstName=' + entity.firstName;
      searchUrl += firstName;
    }
    if (entity.lastName) {
      lastName = '&lastName=' + entity.lastName;
      searchUrl += lastName;
    }
    if (entity.telephone) {
      telephone = '&telephone=' + entity.telephone;
      searchUrl += telephone;
    }
    if (entity.activated) {
      activated = '&activated=' + entity.activated;
      searchUrl += activated;
    }
  };

  const { match } = props;
  const columns = [
    {
      title: 'Prénoms',
      dataIndex: 'prenom',
      key: 'prenom',
    },
    {
      title: 'Nom',
      dataIndex: 'nom',
      key: 'nom',
    },
    {
      title: 'telephone',
      dataIndex: 'telephone',
      key: 'telephone',
    },
    {
      title: 'Status',
      dataIndex: 'activated',
      key: 'activated',
      render: activated => (activated === true ? <Tag color="green">Active</Tag> : <Tag color="red">Inactive</Tag>),
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/parent/${currentEcole && currentEcole.id}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];

  const data = parentList
    .map((parent, i) => ({
      id: parent.parentId,
      nom: parent.lastName,
      prenom: parent.firstName,
      activated: parent.activated,
      telephone: parent.telephone,
    }))
    .reverse();

  return (
    <>
      <h2 id="parent-heading" data-cy="ParentHeading">
        Parents
      </h2>

      <Form name="basic" layout="inline" onFinish={onSearch}>
        <Form.Item name="firstName">
          <Input placeholder="Prénoms" allowClear onChange={parentListe} />
        </Form.Item>
        <Form.Item name="lastName">
          <Input placeholder="Nom" allowClear onChange={parentListe} />
        </Form.Item>
        <Form.Item name="telephone">
          <Input placeholder="Téléphone" allowClear onChange={parentListe} />
        </Form.Item>
        <Form.Item name="activated">
          <Select placeholder="Status" allowClear style={{ width: '150px' }} onChange={parentListe}>
            <Select.Option value="true">
              <Tag color="green">Active</Tag>
            </Select.Option>
            <Select.Option value="false">
              <Tag color="red">Inactive</Tag>
            </Select.Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" icon={<SearchOutlined />} className="mx-1"></Button>
        </Form.Item>
        <div className="table-responsive mt-3">
          <Spin spinning={loading} tip="Chargement...">
            <Table columns={columns} dataSource={data.reverse()} pagination={false} />
          </Spin>
        </div>
        <div className={parentList && parentList.length > 0 ? 'table-responsive' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      </Form>
    </>
  );
};

export default Parent;
